const projectCategories = [
  "All",
  "HTML",
  "MERN",
  "Cyber Security",
  "Data Engineering",
  "Data Science",
  "Mobile Dev",
  "UI/UX",
  "Web Dev",
]

type ProjectCardProps = {
  title: string
  description: string
}

function ProjectCard({ title, description }: ProjectCardProps) {
  return (
    <div className="bg-white border rounded-lg overflow-hidden">
      <div className="h-48 bg-gray-100 flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-gray-400"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
      </div>
      <div className="p-4">
        <h3 className="font-medium">{title}</h3>
        <p className="text-sm text-gray-600 mt-1">{description}</p>
      </div>
    </div>
  )
}

export default function ProjectsSection() {
  return (
    <section className="px-6 pb-10">
      <div className="flex items-center gap-2 mb-4">
        <div className="bg-blue-100 p-1 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-blue-500"
          >
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>
        <h2 className="font-medium">Projects & Certifications</h2>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2 mb-4">
        {projectCategories.map((category) => (
          <button
            key={category}
            className={`px-3 py-1 rounded-full text-sm whitespace-nowrap ${
              category === "All" ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <ProjectCard
          title="Personal Finance Tracker"
          description="A web app to help users track their income and expenses, providing budgeting insights."
        />
        <ProjectCard
          title="AI-Powered Chatbot"
          description="An AI chatbot using natural language processing to assist with customer inquiries."
        />
        <ProjectCard
          title="Smart Home Automation"
          description="A system that integrates IoT devices to control home appliances remotely."
        />
        <ProjectCard
          title="Interactive Data Dashboard"
          description="A dynamic dashboard using Python and JS to visualize real-time data insights."
        />
        <ProjectCard
          title="Multiplayer Online Game"
          description="A browser-based multiplayer game with real-time interaction using WebSockets."
        />
      </div>
    </section>
  )
}

